// extracted by mini-css-extract-plugin
export default {"landing-bio":"landing-bio_landing-bio__4fHFE","bio":"landing-bio_bio__pdk9H","text":"landing-bio_text__2QJsB"};